import * as Sentry from '@sentry/browser'
import React, { useEffect, useState } from 'react'
import { flowRight as compose } from 'lodash'
import { useTranslation } from 'react-i18next'

import {
  BranchDetail as Content,
  BranchService,
  Branch,
  initialBranchDetail,
  renderBreadcrumbsDetail,
} from 'features/Branch'

import { Button } from 'components'
import { useBreadcrumbs } from 'helpers/hooks'
import { withBackOfficeCms } from 'helpers/hocs'
import { routes } from 'helpers/routes'
import { RouteChildrenProps } from 'react-router'
import { useParams } from 'react-router-dom'

const BranchDetail = ({
  history,
  match,
}: RouteChildrenProps<{ id: string }>): JSX.Element => {
  const params = useParams<{ id: string }>()

  const [loading, setLoading] = useState<boolean>(false)
  const [contentData, setContentData] = useState<Branch>(initialBranchDetail)

  const { t } = useTranslation(['layout', 'common'])

  const base = 'con-branch'
  const id = match?.params.id || ''

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      setLoading(true)
      const content = await BranchService.findBranchById(id)
      setContentData(content.data || initialBranchDetail)
      setLoading(false)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  useBreadcrumbs(renderBreadcrumbsDetail(params.id))

  return (
    <div className={`${base}__container ${base}__container-detail`}>
      <Content data={contentData} loading={loading} />
      <div className={`${base}__con-detail-bottom`}>
        <Button
          className={`${base}__form-btn`}
          onClick={() => history.push(`${routes.branch.path}/${id}/edit`)}
          variants='primary'
        >
          {t('common:edit.button')}
        </Button>
      </div>
    </div>
  )
}

export default compose(withBackOfficeCms)(BranchDetail)
